import { IPageLayoutType } from "../../types/pageLayoutTypes";

export const useAccessionDetails = () => {
  const rowData = [
    {
      id: "9002",
      created: "01/05/2024",
      studyID: "ONC-NSCLC-2024-01",
      assessmentPlan: "Mutation status for study eligibility",
      status: "In Progress",
      lastupdate: "07/02/2024",
      accession_id: "9002",
      isNew: true,
    },
    {
      id: "9003",
      created: "04/16/2024",
      studyID: "ONC-NSCLC-2024-01",
      assessmentPlan: "Mutation status for study eligibility",
      status: "In Progress",
      lastupdate: "06/27/2024",
      accession_id: "9002",
      isUpdated: true,
    },
    {
      id: "9004",
      badge: "",
      created: "04/20/2024",
      studyID: "ONC-NSCLC-2024-01",
      assessmentPlan: "Mutation status for study eligibility",
      status: "In Progress",
      lastupdate: "07/02/2024",
      accession_id: "9002",
    },
    {
      id: "9005",
      badge: "",
      created: "04/22/2024",
      studyID: "ONC-NSCLC-2024-01",
      assessmentPlan: "Mutation status for study eligibility",
      status: "In Progress",
      lastupdate: "06/27/2024",
      accession_id: "9002",
    },
  ];
  const accessionDetailsContentJson: IPageLayoutType[] = [
    {
      title: "",
      description: "",
      content: [
        {
          label: "Study ID",
          value: "ONC-NSCLC-2024-01",
          size: {
            mediumScreen: 12,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Assessment Plan",
          value: "ONC-NSCLC-2024-01-SC1001",
          size: {
            mediumScreen: 12,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Procedure Name",
          value: "New slide",
          size: {
            mediumScreen: 12,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Patient ID",
          value: "3333-222",
          size: {
            mediumScreen: 12,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Procedure Protocol",
          value: "Label",
          size: {
            mediumScreen: 12,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Priority",
          value: "Routine",
          size: {
            mediumScreen: 12,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Origin",
          value: "Site#1001",
          size: {
            mediumScreen: 12,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Destination",
          value: "CL# 1987",
          size: {
            mediumScreen: 12,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Shipping Condition",
          value: "Room Temperature",
          size: {
            mediumScreen: 12,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Expected Date",
          value: "05-01-2024",
          size: {
            mediumScreen: 12,
            extraSmallScreen: 12,
          },
        },
      ],
    },
  ];
  const timeLineDetails = [
    {
      step: "Created",
      by: "John Smith",
      date: "01/05/2024 8:00AM",
      locationId: "CL 1987",
      locationName: "Lab Corp A32",
    },
    {
      step: "Recieved",
      by: "John Smith",
      date: "01/05/2024 8:00AM",
      locationId: "CL 1987",
      locationName: "Lab Corp A32",
    },
    {
      step: "Initiated",
      by: "John Smith",
      date: "01/05/2024 8:00AM",
      locationId: "CL 1987",
      locationName: "Lab Corp A32",
    },
    {
      step: "Processed",
      by: "John Smith",
      date: "01/05/2024 8:00AM",
      locationId: "CL 1987",
      locationName: "Lab Corp A32",
    },
    {
      step: "Staged",
      by: "John Smith",
      date: "01/05/2024 8:00AM",
      locationId: "CL 1987",
      locationName: "Lab Corp A32",
    },
    {
      step: "Dispatched",
      by: "John Smith",
      date: "01/05/2024 8:00AM",
      locationId: "CL 1987",
      locationName: "Lab Corp A32",
    },
    {
      step: "Arrived",
      by: "John Smith",
      date: "01/05/2024 8:00AM",
      locationId: "CL 1987",
      locationName: "Lab Corp A32",
    },
  ];
  return {
    rowData,
    accessionDetailsContentJson,
    timeLineDetails,
  };
};
